module.exports = __webpack_public_path__ + "img/install-devices-nl.5f24cfc0.png";